




import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class HIVEStepperStep extends Vue {
  @Prop(Boolean) public isEditable: boolean
  @Prop(Number) public step: number
  @Prop(String) public formTitlePrefix: string
  @Prop(String) public formTitleSuffix: string

  public get getIsStepEditable() {
    return this.isEditable
  }

  public get getStep() {
    return this.step
  }

  public get getFormTitlePrefix() {
    return this.formTitlePrefix
  }

  public get getFormTitleSuffix() {
    return this.formTitleSuffix
  }
}
